/**
 * TVG-339: what the customer said about a viewing.
 *
 * Shared by the two surfaces that show it — the show rounds page and the show
 * rounds panel on a contact record — because both print the same three answers
 * and the same comment, and a second copy of the shape is a second thing to
 * keep right.
 *
 * Only ever present on a round the customer has answered about. A round with
 * no review either has not been asked yet, or has been asked and not replied.
 */
export interface ShowRoundReview {
  viewing_rating: 'great' | 'ok' | 'bad' | null;
  viewing_rating_label: string | null;
  venue_rating: 'great' | 'ok' | 'bad' | null;
  venue_rating_label: string | null;
  getting_married: 'yes' | 'maybe' | 'no' | null;
  getting_married_label: string | null;
  /** Richard's "Any other feedback?" box, which is optional. */
  feedback: string | null;
  submitted_at: string;
}

/**
 * The colour a rating reads in. Great and Yes are good news, Bad and No are
 * the ones worth surfacing while there is still time to recover the
 * relationship, which is the whole point of asking.
 */
export function showRoundReviewClasses(value: string | null): string {
  switch (value) {
    case 'great':
    case 'yes':
      return 'bg-success-50 text-success-700 dark:bg-success-500/15 dark:text-success-400';
    case 'bad':
    case 'no':
      return 'bg-error-50 text-error-700 dark:bg-error-500/15 dark:text-error-400';
    default:
      return 'bg-warning-50 text-warning-700 dark:bg-warning-500/15 dark:text-warning-400';
  }
}
